import { render, staticRenderFns } from "./DepartmentsView.vue?vue&type=template&id=4282b818&scoped=true&"
import script from "./DepartmentsView.vue?vue&type=script&lang=js&"
export * from "./DepartmentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4282b818",
  null
  
)

export default component.exports